import { useDataLoaderHooks } from './use-dataloader-hooks'

export const useNotifyAddToCart = () => {
  const { notifyAddToCart } = useDataLoaderHooks()

  return notifyAddToCart()
}
